import { Component, Input, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ContractService } from '../../../features/contract/contract.service';
import { getRequestCountResponse } from '../../../features/contract/contract.types';
import { TourService } from '../../../shared/services/tour.service';
import { AppTourStep } from '../../../shared/models/tour-step.model';
import { SubjectService } from '../../services/subject.service';
import { SidebarService } from './sidebar.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  @Input() isOpen: boolean = false;
  @Input() isToggle: boolean = false;
  public contractRequestCount: number = 0;
  public role: number = 0;
  public unverifiedPrimer: number = 0;
  public unverifiedCustomer: number = 0;

  constructor(private router:Router, private cookieService:CookieService, private translate:TranslateService, private sidebarService:SidebarService, private contractService:ContractService, private tourService: TourService, private subject:SubjectService){
    const savedLang = this.cookieService.get('language') || 'en';
    this.translate.setDefaultLang(savedLang);
    this.translate.use(savedLang);
  }


  ngOnInit(){
    if (this.cookieService.get('user')) {
      this.role = JSON.parse(this.cookieService.get('user')).role;
      this.getRequestCount();
      this.getContractRequestCount();

      if(this.role === 1) {
        this.updateUnverifiedCustomer();
        this.getUnverifiedPrimer();
        this.getUnverifiedCustomer();
      }
    }
  }

  getContractRequestCount(){
    this.contractService.getMessages(`framework-${JSON.parse(this.cookieService.get('user')).id}`).subscribe((data:string)=>{
      this.getRequestCount();
    })
  }

  getRequestCount(){
    this.contractService.getRequestCount(JSON.parse(this.cookieService.get('user')).id).subscribe((data:getRequestCountResponse)=>{
      this.contractRequestCount = data.data;
    })
  }

  updateUnverifiedCustomer() {
    if(this.role === 1) {
      this.sidebarService.getMessages(`user-updateCustomerCount`).subscribe(()=>{
        this.getUnverifiedCustomer();
      })
    }
  }


  close(){
    this.isOpen=false
  }

  navigate(path:string){
    this.router.navigate([path])
    this.isOpen = false;
  }

  startSidebarTour(): void {
    this.tourService.startSidebarTour();
  }

  getUnverifiedPrimer() {
    this.sidebarService.getUnverifiedPrimer().subscribe((data)=>{
      this.unverifiedPrimer = data.total;
    })
  }

  getUnverifiedCustomer() {
    this.sidebarService.getUnverifiedCustomer().subscribe((data)=>{
      this.unverifiedCustomer = data.total;
    })
  }


}
